(function($, Drupal) {
  Drupal.behaviors.wistia = {
    attach(context, settings) {
      // Global wistia - pause others when one is played
      window._wq = window._wq || [];
      window._wq.push({
        id: "_all",
        onReady: function(video) {
          // for all existing and future videos, run this function
          video.bind("play", function() {
            // when one video plays, iterate over all the videos and pause each,
            // unless it's the video that just started playing.
            var allVideos = Wistia.api.all();
            for (var i = 0; i < allVideos.length; i++) {
              if (allVideos[i].hashedId() !== video.hashedId()) {
                allVideos[i].pause();
              }
            }
          });

          // Slick slider pause all videos before sliding
          if ($(".campaign__slider").length) {
            var $slider = $(".campaign__slider");
            $slider.on("afterChange", function(
              event,
              slick,
              currentSlide,
              nextSlide
            ) {
              var allVideos = Wistia.api.all();
              for (var i = 0; i < allVideos.length; i++) {
                allVideos[i].pause();
              }
            });
          }
          // Slick slider pause all videos before sliding
          if ($(".slider--COMPLEX").length) {
            var $sliderComplex = $(".slider--COMPLEX");
            $sliderComplex.on("afterChange", function() {
              var allVideos = Wistia.api.all();
              for (var i = 0; i < allVideos.length; i++) {
                allVideos[i].pause();
              }
            });
          }
          if ($(".slider--PLAIN").length) {
            var $sliderPlain = $(".slider--COMPLEX");
            $sliderPlain.on("afterChange", function() {
              var allVideos = Wistia.api.all();
              for (var i = 0; i < allVideos.length; i++) {
                allVideos[i].pause();
              }
            });
          }
        }
      });
    }
  };
})(jQuery, Drupal);
